import type React from 'react';
import { Link } from 'react-router-dom';
import { formatJst } from '../../lib/format.ts';
import type { PreviewRankingResponse } from '../../types/ranking.ts';

type Props = { data: PreviewRankingResponse };

export const PreviewTable = ({ data }: Props): React.JSX.Element => (
  <>
    <p style={previewNoteStyle}>
      暫定ランキング（直近 30 日の signals 集計）。統合スコア計算を実行すると本番ランキングに切り替わります。
    </p>
    <ul style={listStyle}>
      {data.rows.map((row, idx) => (
        <li key={row.industry_id} style={rowStyle}>
          <span style={rankStyle}>{idx + 1}</span>
          <Link to={`/industry/${row.industry_id}`} style={nameStyle}>
            {row.name}
          </Link>
          <span style={codeStyle}>{row.code}</span>
          <span style={valueStyle}>signals: {row.total_signals}</span>
        </li>
      ))}
    </ul>
    <small style={mutedStyle}>更新: {formatJst(data.data_updated_at)}</small>
  </>
);

const listStyle: React.CSSProperties = { margin: 0, padding: 0, listStyle: 'none' };
const rowStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '40px 1fr 200px 120px',
  alignItems: 'center',
  padding: '10px 16px',
  borderBottom: '1px solid #f0f0f0',
};
const rankStyle: React.CSSProperties = { fontWeight: 700 };
const nameStyle: React.CSSProperties = { textDecoration: 'none', color: '#1976d2' };
const codeStyle: React.CSSProperties = { color: '#777', fontSize: 12, fontFamily: 'monospace' };
const valueStyle: React.CSSProperties = { color: '#444', fontSize: 13, textAlign: 'right' };
const mutedStyle: React.CSSProperties = { color: '#888', fontSize: 13, padding: '12px 16px' };
const previewNoteStyle: React.CSSProperties = {
  color: '#777',
  fontSize: 12,
  padding: '8px 16px',
  background: '#fff8e1',
  margin: 0,
  borderBottom: '1px solid #f0f0f0',
};
